module.exports = __webpack_public_path__ + "img/remortCardClear.597863d3.png";